/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root"
import { Route as SettingsRouteImport } from "./routes/settings"
import { Route as ModerationRouteImport } from "./routes/moderation"
import { Route as LoginRouteImport } from "./routes/login"
import { Route as IndexRouteImport } from "./routes/index"
import { Route as ScenesIndexRouteImport } from "./routes/scenes/index"
import { Route as ProfileIndexRouteImport } from "./routes/profile/index"
import { Route as NotificationsIndexRouteImport } from "./routes/notifications/index"
import { Route as MessagesIndexRouteImport } from "./routes/messages/index"
import { Route as EventsIndexRouteImport } from "./routes/events/index"
import { Route as ClubsIndexRouteImport } from "./routes/clubs/index"
import { Route as SettingsLegalRouteImport } from "./routes/settings_.legal"
import { Route as ProfileUserIdRouteImport } from "./routes/profile/$userId"
import { Route as PPostIdRouteImport } from "./routes/p/$postId"
import { Route as JoinIdentifierRouteImport } from "./routes/join/$identifier"
import { Route as InviteInviteTokenRouteImport } from "./routes/invite/$inviteToken"
import { Route as EventsIdentifierRouteImport } from "./routes/events/$identifier"
import { Route as EIdentifierRouteImport } from "./routes/e/$identifier"
import { Route as ClubsIdentifierRouteImport } from "./routes/clubs/$identifier"
import { Route as CIdentifierRouteImport } from "./routes/c/$identifier"
import { Route as AuthCallbackRouteImport } from "./routes/auth/callback"
import { Route as SettingsClubSubscriptionClubIdRouteImport } from "./routes/settings_.club-subscription.$clubId"
import { Route as ClubsClubIdPricingRouteImport } from "./routes/clubs/$clubId_.pricing"
import { Route as ClubsClubIdPostsPostIdRouteImport } from "./routes/clubs/$clubId_.posts.$postId"

const SettingsRoute = SettingsRouteImport.update({
  id: "/settings",
  path: "/settings",
  getParentRoute: () => rootRouteImport,
} as any)
const ModerationRoute = ModerationRouteImport.update({
  id: "/moderation",
  path: "/moderation",
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: "/login",
  path: "/login",
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => rootRouteImport,
} as any)
const ScenesIndexRoute = ScenesIndexRouteImport.update({
  id: "/scenes/",
  path: "/scenes/",
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileIndexRoute = ProfileIndexRouteImport.update({
  id: "/profile/",
  path: "/profile/",
  getParentRoute: () => rootRouteImport,
} as any)
const NotificationsIndexRoute = NotificationsIndexRouteImport.update({
  id: "/notifications/",
  path: "/notifications/",
  getParentRoute: () => rootRouteImport,
} as any)
const MessagesIndexRoute = MessagesIndexRouteImport.update({
  id: "/messages/",
  path: "/messages/",
  getParentRoute: () => rootRouteImport,
} as any)
const EventsIndexRoute = EventsIndexRouteImport.update({
  id: "/events/",
  path: "/events/",
  getParentRoute: () => rootRouteImport,
} as any)
const ClubsIndexRoute = ClubsIndexRouteImport.update({
  id: "/clubs/",
  path: "/clubs/",
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsLegalRoute = SettingsLegalRouteImport.update({
  id: "/settings_/legal",
  path: "/settings/legal",
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileUserIdRoute = ProfileUserIdRouteImport.update({
  id: "/profile/$userId",
  path: "/profile/$userId",
  getParentRoute: () => rootRouteImport,
} as any)
const PPostIdRoute = PPostIdRouteImport.update({
  id: "/p/$postId",
  path: "/p/$postId",
  getParentRoute: () => rootRouteImport,
} as any)
const JoinIdentifierRoute = JoinIdentifierRouteImport.update({
  id: "/join/$identifier",
  path: "/join/$identifier",
  getParentRoute: () => rootRouteImport,
} as any)
const InviteInviteTokenRoute = InviteInviteTokenRouteImport.update({
  id: "/invite/$inviteToken",
  path: "/invite/$inviteToken",
  getParentRoute: () => rootRouteImport,
} as any)
const EventsIdentifierRoute = EventsIdentifierRouteImport.update({
  id: "/events/$identifier",
  path: "/events/$identifier",
  getParentRoute: () => rootRouteImport,
} as any)
const EIdentifierRoute = EIdentifierRouteImport.update({
  id: "/e/$identifier",
  path: "/e/$identifier",
  getParentRoute: () => rootRouteImport,
} as any)
const ClubsIdentifierRoute = ClubsIdentifierRouteImport.update({
  id: "/clubs/$identifier",
  path: "/clubs/$identifier",
  getParentRoute: () => rootRouteImport,
} as any)
const CIdentifierRoute = CIdentifierRouteImport.update({
  id: "/c/$identifier",
  path: "/c/$identifier",
  getParentRoute: () => rootRouteImport,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: "/auth/callback",
  path: "/auth/callback",
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsClubSubscriptionClubIdRoute =
  SettingsClubSubscriptionClubIdRouteImport.update({
    id: "/settings_/club-subscription/$clubId",
    path: "/settings/club-subscription/$clubId",
    getParentRoute: () => rootRouteImport,
  } as any)
const ClubsClubIdPricingRoute = ClubsClubIdPricingRouteImport.update({
  id: "/clubs/$clubId_/pricing",
  path: "/clubs/$clubId/pricing",
  getParentRoute: () => rootRouteImport,
} as any)
const ClubsClubIdPostsPostIdRoute = ClubsClubIdPostsPostIdRouteImport.update({
  id: "/clubs/$clubId_/posts/$postId",
  path: "/clubs/$clubId/posts/$postId",
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  "/": typeof IndexRoute
  "/login": typeof LoginRoute
  "/moderation": typeof ModerationRoute
  "/settings": typeof SettingsRoute
  "/auth/callback": typeof AuthCallbackRoute
  "/c/$identifier": typeof CIdentifierRoute
  "/clubs/$identifier": typeof ClubsIdentifierRoute
  "/e/$identifier": typeof EIdentifierRoute
  "/events/$identifier": typeof EventsIdentifierRoute
  "/invite/$inviteToken": typeof InviteInviteTokenRoute
  "/join/$identifier": typeof JoinIdentifierRoute
  "/p/$postId": typeof PPostIdRoute
  "/profile/$userId": typeof ProfileUserIdRoute
  "/settings/legal": typeof SettingsLegalRoute
  "/clubs/": typeof ClubsIndexRoute
  "/events/": typeof EventsIndexRoute
  "/messages/": typeof MessagesIndexRoute
  "/notifications/": typeof NotificationsIndexRoute
  "/profile/": typeof ProfileIndexRoute
  "/scenes/": typeof ScenesIndexRoute
  "/clubs/$clubId/pricing": typeof ClubsClubIdPricingRoute
  "/settings/club-subscription/$clubId": typeof SettingsClubSubscriptionClubIdRoute
  "/clubs/$clubId/posts/$postId": typeof ClubsClubIdPostsPostIdRoute
}
export interface FileRoutesByTo {
  "/": typeof IndexRoute
  "/login": typeof LoginRoute
  "/moderation": typeof ModerationRoute
  "/settings": typeof SettingsRoute
  "/auth/callback": typeof AuthCallbackRoute
  "/c/$identifier": typeof CIdentifierRoute
  "/clubs/$identifier": typeof ClubsIdentifierRoute
  "/e/$identifier": typeof EIdentifierRoute
  "/events/$identifier": typeof EventsIdentifierRoute
  "/invite/$inviteToken": typeof InviteInviteTokenRoute
  "/join/$identifier": typeof JoinIdentifierRoute
  "/p/$postId": typeof PPostIdRoute
  "/profile/$userId": typeof ProfileUserIdRoute
  "/settings/legal": typeof SettingsLegalRoute
  "/clubs": typeof ClubsIndexRoute
  "/events": typeof EventsIndexRoute
  "/messages": typeof MessagesIndexRoute
  "/notifications": typeof NotificationsIndexRoute
  "/profile": typeof ProfileIndexRoute
  "/scenes": typeof ScenesIndexRoute
  "/clubs/$clubId/pricing": typeof ClubsClubIdPricingRoute
  "/settings/club-subscription/$clubId": typeof SettingsClubSubscriptionClubIdRoute
  "/clubs/$clubId/posts/$postId": typeof ClubsClubIdPostsPostIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  "/": typeof IndexRoute
  "/login": typeof LoginRoute
  "/moderation": typeof ModerationRoute
  "/settings": typeof SettingsRoute
  "/auth/callback": typeof AuthCallbackRoute
  "/c/$identifier": typeof CIdentifierRoute
  "/clubs/$identifier": typeof ClubsIdentifierRoute
  "/e/$identifier": typeof EIdentifierRoute
  "/events/$identifier": typeof EventsIdentifierRoute
  "/invite/$inviteToken": typeof InviteInviteTokenRoute
  "/join/$identifier": typeof JoinIdentifierRoute
  "/p/$postId": typeof PPostIdRoute
  "/profile/$userId": typeof ProfileUserIdRoute
  "/settings_/legal": typeof SettingsLegalRoute
  "/clubs/": typeof ClubsIndexRoute
  "/events/": typeof EventsIndexRoute
  "/messages/": typeof MessagesIndexRoute
  "/notifications/": typeof NotificationsIndexRoute
  "/profile/": typeof ProfileIndexRoute
  "/scenes/": typeof ScenesIndexRoute
  "/clubs/$clubId_/pricing": typeof ClubsClubIdPricingRoute
  "/settings_/club-subscription/$clubId": typeof SettingsClubSubscriptionClubIdRoute
  "/clubs/$clubId_/posts/$postId": typeof ClubsClubIdPostsPostIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | "/"
    | "/login"
    | "/moderation"
    | "/settings"
    | "/auth/callback"
    | "/c/$identifier"
    | "/clubs/$identifier"
    | "/e/$identifier"
    | "/events/$identifier"
    | "/invite/$inviteToken"
    | "/join/$identifier"
    | "/p/$postId"
    | "/profile/$userId"
    | "/settings/legal"
    | "/clubs/"
    | "/events/"
    | "/messages/"
    | "/notifications/"
    | "/profile/"
    | "/scenes/"
    | "/clubs/$clubId/pricing"
    | "/settings/club-subscription/$clubId"
    | "/clubs/$clubId/posts/$postId"
  fileRoutesByTo: FileRoutesByTo
  to:
    | "/"
    | "/login"
    | "/moderation"
    | "/settings"
    | "/auth/callback"
    | "/c/$identifier"
    | "/clubs/$identifier"
    | "/e/$identifier"
    | "/events/$identifier"
    | "/invite/$inviteToken"
    | "/join/$identifier"
    | "/p/$postId"
    | "/profile/$userId"
    | "/settings/legal"
    | "/clubs"
    | "/events"
    | "/messages"
    | "/notifications"
    | "/profile"
    | "/scenes"
    | "/clubs/$clubId/pricing"
    | "/settings/club-subscription/$clubId"
    | "/clubs/$clubId/posts/$postId"
  id:
    | "__root__"
    | "/"
    | "/login"
    | "/moderation"
    | "/settings"
    | "/auth/callback"
    | "/c/$identifier"
    | "/clubs/$identifier"
    | "/e/$identifier"
    | "/events/$identifier"
    | "/invite/$inviteToken"
    | "/join/$identifier"
    | "/p/$postId"
    | "/profile/$userId"
    | "/settings_/legal"
    | "/clubs/"
    | "/events/"
    | "/messages/"
    | "/notifications/"
    | "/profile/"
    | "/scenes/"
    | "/clubs/$clubId_/pricing"
    | "/settings_/club-subscription/$clubId"
    | "/clubs/$clubId_/posts/$postId"
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  LoginRoute: typeof LoginRoute
  ModerationRoute: typeof ModerationRoute
  SettingsRoute: typeof SettingsRoute
  AuthCallbackRoute: typeof AuthCallbackRoute
  CIdentifierRoute: typeof CIdentifierRoute
  ClubsIdentifierRoute: typeof ClubsIdentifierRoute
  EIdentifierRoute: typeof EIdentifierRoute
  EventsIdentifierRoute: typeof EventsIdentifierRoute
  InviteInviteTokenRoute: typeof InviteInviteTokenRoute
  JoinIdentifierRoute: typeof JoinIdentifierRoute
  PPostIdRoute: typeof PPostIdRoute
  ProfileUserIdRoute: typeof ProfileUserIdRoute
  SettingsLegalRoute: typeof SettingsLegalRoute
  ClubsIndexRoute: typeof ClubsIndexRoute
  EventsIndexRoute: typeof EventsIndexRoute
  MessagesIndexRoute: typeof MessagesIndexRoute
  NotificationsIndexRoute: typeof NotificationsIndexRoute
  ProfileIndexRoute: typeof ProfileIndexRoute
  ScenesIndexRoute: typeof ScenesIndexRoute
  ClubsClubIdPricingRoute: typeof ClubsClubIdPricingRoute
  SettingsClubSubscriptionClubIdRoute: typeof SettingsClubSubscriptionClubIdRoute
  ClubsClubIdPostsPostIdRoute: typeof ClubsClubIdPostsPostIdRoute
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/settings": {
      id: "/settings"
      path: "/settings"
      fullPath: "/settings"
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/moderation": {
      id: "/moderation"
      path: "/moderation"
      fullPath: "/moderation"
      preLoaderRoute: typeof ModerationRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/login": {
      id: "/login"
      path: "/login"
      fullPath: "/login"
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/": {
      id: "/"
      path: "/"
      fullPath: "/"
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/scenes/": {
      id: "/scenes/"
      path: "/scenes"
      fullPath: "/scenes/"
      preLoaderRoute: typeof ScenesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/profile/": {
      id: "/profile/"
      path: "/profile"
      fullPath: "/profile/"
      preLoaderRoute: typeof ProfileIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/notifications/": {
      id: "/notifications/"
      path: "/notifications"
      fullPath: "/notifications/"
      preLoaderRoute: typeof NotificationsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/messages/": {
      id: "/messages/"
      path: "/messages"
      fullPath: "/messages/"
      preLoaderRoute: typeof MessagesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/events/": {
      id: "/events/"
      path: "/events"
      fullPath: "/events/"
      preLoaderRoute: typeof EventsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/clubs/": {
      id: "/clubs/"
      path: "/clubs"
      fullPath: "/clubs/"
      preLoaderRoute: typeof ClubsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/settings_/legal": {
      id: "/settings_/legal"
      path: "/settings/legal"
      fullPath: "/settings/legal"
      preLoaderRoute: typeof SettingsLegalRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/profile/$userId": {
      id: "/profile/$userId"
      path: "/profile/$userId"
      fullPath: "/profile/$userId"
      preLoaderRoute: typeof ProfileUserIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/p/$postId": {
      id: "/p/$postId"
      path: "/p/$postId"
      fullPath: "/p/$postId"
      preLoaderRoute: typeof PPostIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/join/$identifier": {
      id: "/join/$identifier"
      path: "/join/$identifier"
      fullPath: "/join/$identifier"
      preLoaderRoute: typeof JoinIdentifierRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/invite/$inviteToken": {
      id: "/invite/$inviteToken"
      path: "/invite/$inviteToken"
      fullPath: "/invite/$inviteToken"
      preLoaderRoute: typeof InviteInviteTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/events/$identifier": {
      id: "/events/$identifier"
      path: "/events/$identifier"
      fullPath: "/events/$identifier"
      preLoaderRoute: typeof EventsIdentifierRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/e/$identifier": {
      id: "/e/$identifier"
      path: "/e/$identifier"
      fullPath: "/e/$identifier"
      preLoaderRoute: typeof EIdentifierRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/clubs/$identifier": {
      id: "/clubs/$identifier"
      path: "/clubs/$identifier"
      fullPath: "/clubs/$identifier"
      preLoaderRoute: typeof ClubsIdentifierRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/c/$identifier": {
      id: "/c/$identifier"
      path: "/c/$identifier"
      fullPath: "/c/$identifier"
      preLoaderRoute: typeof CIdentifierRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/auth/callback": {
      id: "/auth/callback"
      path: "/auth/callback"
      fullPath: "/auth/callback"
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/settings_/club-subscription/$clubId": {
      id: "/settings_/club-subscription/$clubId"
      path: "/settings/club-subscription/$clubId"
      fullPath: "/settings/club-subscription/$clubId"
      preLoaderRoute: typeof SettingsClubSubscriptionClubIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/clubs/$clubId_/pricing": {
      id: "/clubs/$clubId_/pricing"
      path: "/clubs/$clubId/pricing"
      fullPath: "/clubs/$clubId/pricing"
      preLoaderRoute: typeof ClubsClubIdPricingRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/clubs/$clubId_/posts/$postId": {
      id: "/clubs/$clubId_/posts/$postId"
      path: "/clubs/$clubId/posts/$postId"
      fullPath: "/clubs/$clubId/posts/$postId"
      preLoaderRoute: typeof ClubsClubIdPostsPostIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  LoginRoute: LoginRoute,
  ModerationRoute: ModerationRoute,
  SettingsRoute: SettingsRoute,
  AuthCallbackRoute: AuthCallbackRoute,
  CIdentifierRoute: CIdentifierRoute,
  ClubsIdentifierRoute: ClubsIdentifierRoute,
  EIdentifierRoute: EIdentifierRoute,
  EventsIdentifierRoute: EventsIdentifierRoute,
  InviteInviteTokenRoute: InviteInviteTokenRoute,
  JoinIdentifierRoute: JoinIdentifierRoute,
  PPostIdRoute: PPostIdRoute,
  ProfileUserIdRoute: ProfileUserIdRoute,
  SettingsLegalRoute: SettingsLegalRoute,
  ClubsIndexRoute: ClubsIndexRoute,
  EventsIndexRoute: EventsIndexRoute,
  MessagesIndexRoute: MessagesIndexRoute,
  NotificationsIndexRoute: NotificationsIndexRoute,
  ProfileIndexRoute: ProfileIndexRoute,
  ScenesIndexRoute: ScenesIndexRoute,
  ClubsClubIdPricingRoute: ClubsClubIdPricingRoute,
  SettingsClubSubscriptionClubIdRoute: SettingsClubSubscriptionClubIdRoute,
  ClubsClubIdPostsPostIdRoute: ClubsClubIdPostsPostIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
